import { MenuItem, Select } from '@material-ui/core'
import React from 'react'
import LazyLoad from 'react-lazyload'
import styled from 'styled-components'

type IProps = {
  language: string
  handleChange: (event: React.ChangeEvent<{ value: string }>) => void
}

const SwitchLang = (props: IProps) => {
  return (
    <>
      <LazyLoad>
        <Select defaultValue={props.language} value={props.language} onChange={props.handleChange}>
          <MenuItemWrapper dense value={'EN'}>
            <img className="language-icon" src={'/images/home/usa-icon.png'} alt="en" />
            <a>{'English'}</a>
          </MenuItemWrapper>
          <MenuItemWrapper dense value={'ID'}>
            <img className="language-icon" src={'/images/home/id-icon.png'} alt="id" />
            <a>{'ID'}</a>
          </MenuItemWrapper>
        </Select>
      </LazyLoad>
    </>
  )
}

export default SwitchLang

const MenuItemWrapper = styled(MenuItem)`
  &.MuiListItem-root.Mui-selected {
    background-color: #ccc;
  }
  &.MuiListItem-root.Mui-selected:hover {
    background-color: #ccc;
  }
`
